import { useState } from "react";

import { debounce } from "../utils/helpers/debounce";

export const useSearchFilter = (debounceTime = 300) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = debounce(event => {
    setSearchQuery(event.target.value);
  }, debounceTime);

  const filterData = data => {
    const trimmedQuery = searchQuery.trim().toLowerCase();
    return data.filter(item =>
      item.attribute.toLowerCase().includes(trimmedQuery),
    );
  };

  return {
    handleSearchChange,
    filterData,
  };
};
